import Http from '@/utils/http'

const USER_URL = '/account/users/'

export const postUser = (data) => Http.post(USER_URL, data)
export const getUser = (id) => {
  return Http.get(`${USER_URL + id}/`)
}
export const getUsers = () => Http.get(USER_URL)
export const deleteUser = (id) => {
  return Http.delete(`${USER_URL + id}/`)
}
export const putUser = (data) => {
  return Http.put(`${USER_URL + data.id}/`)
}

export const searchUser = (userQuery) => {
  return Http.get(`${USER_URL}?search=${userQuery}`)
}



// WEBPACK FOOTER //
// ./src/services/user.js